import { createTheme } from '@mui/material/styles'

import { dsv } from './defaults'

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: dsv.colors.connectGrau,
      contrastText: dsv.colors.white,
    },
    secondary: {
      main: dsv.colors.GpJouleGelb,
      contrastText: dsv.colors.connectGrau,
    },
    error: {
      main: dsv.colors.error,
    },
    warning: {
      main: dsv.colors.BegleitfarbeOrange,
    },
    success: {
      main: dsv.colors.success,
    },
    info: {
      main: dsv.colors.Kontra,
    },
    text: {
      primary: dsv.colors.connectGrau,
      secondary: dsv.colors.connectGrau70,
      disabled: dsv.colors.connectGrau50,
    },
    divider: dsv.colors.connectGrau30,
    background: {
      default: dsv.colors.base,
      paper: dsv.colors.white,
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: dsv.text.fontFamily,
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          border: `1px solid ${dsv.colors.connectGrau30}`,
          boxShadow: '0 8px 18px rgba(0, 0, 0, 0.16)',
        },
        option: {
          minHeight: 36,
          '&.Mui-focused': {
            backgroundColor: dsv.colors.GpJouleGelb30,
          },
          '&[aria-selected="true"]': {
            backgroundColor: dsv.colors.GpJouleGelb50,
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: dsv.colors.base,
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: dsv.colors.connectGrau70,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: dsv.colors.connectGrau,
            borderWidth: 1,
          },
        },
        notchedOutline: {
          borderColor: dsv.colors.connectGrau30,
        },
      },
    },
  },
})
